__turbopack_context__.v({
  "backdrop": "styles-module-scss-module__cjLI3G__backdrop",
  "skip-label": "styles-module-scss-module__cjLI3G__skip-label",
  "video": "styles-module-scss-module__cjLI3G__video",
  "videoContainer": "styles-module-scss-module__cjLI3G__videoContainer",
});
